// @ts-nocheck
import moment from "moment";
import MetricAndUpDown from '@/pages/dashboard/components/MetricAndUpDown';
import {formatNum, formatPercentNum, getUpAndDownStatus} from '@/pages/dashboard/utils/utils';
import { useLocal } from '@/pages/dashboard/utils/customHook';
import { DEFAULT_OPTIONS } from '../../_constant';

/*
  宽表列名配置
  widthLarge: 指标显示最大长度10位数
  widthMid: 指标显示最大长度8位数
  widthSmall: 指标显示最大长度5位数
  表头标题最少能放下11位数超出用省略号表示，列宽取指标以及表头标题两者的最大值
  20: th & td padding 值
  const widthLarge = 220
  const widthMid = 205
  const widthSmall = 170
*/
const widthLarge = 220 - 20
const widthMid = 205 - 20
const widthSmall = 170 - 20
export { widthLarge, widthMid, widthSmall }

function getStatus(n: string | number) {
  return Number(n) > 0 ? 'up' : 'down';
}

function decimalPlaces(format: string = '') {
  return (format.split('.')[1] ?? '').length
}

/**
 * @desc 格式化函数
 * @param val 值
 * @param format 格式：'0' '0.00', '0.00%'
 * @param unit 单位：$
 * @returns {string}
 */
export function formatVal(val: string | number = '', format: string, unit: string = '') {
  val = val ?? ''
  format = format?.trim() ?? ''

  if (format.includes('%')) {
    val = formatPercentNum(parseFloat(val), decimalPlaces(format.replace('%', '')))
  } else if (format === '0.00') {
    val = formatNum(val)
  } else if (format === '0') {
    val = formatNum(parseFloat(val), !!unit, format === '0')
  }

  return '' + val
}

export function getGroupCols(selected: string[]): MetricsTableColumn<any>[] {
  const th: MetricsTableColumn<any>[] = []
  selected.filter(ele => ele !== 'accumulated').forEach(ele => {
    const headText = DEFAULT_OPTIONS?.find(v => v.value === ele)?.text?.slice(3)
    th.push({
      key: ele,
      header: headText,
      width: 170,
      align: 'left',
      render: (record) => {
        let recordtext = record[`${ele}`] || '-'
        return (<span className='db-PerformanceMetricsTable__text tea-text-overflow'>{recordtext}</span>)
      }
    })
  })
  return th
}

export const useGetGroupCols = () => {
  const { getLocalText } = useLocal('common')
  function getGroupCols(selected: string[]): MetricsTableColumn<any>[] {
    const th: MetricsTableColumn<any>[] = []
    selected.filter(ele => ele !== 'accumulated' && ele !== 'time').forEach(ele => {
      const headText = DEFAULT_OPTIONS?.find(v => v.value.includes(ele))?.text?.slice(3)
      th.push({
        key: ele,
        header: getLocalText(headText?.trim()),
        width: 170,
        align: 'left',
        render: (record) => {
          let recordtext = record[`by_${ele}`] || '-'
          return (<span className='db-PerformanceMetricsTable__text tea-text-overflow'>{recordtext}</span>)
        }
      })
    })
    return th
  }

  return getGroupCols
}

export function noStatusRender() {
  return (
    record: any,
    rowKey: string,
    recordIndex: number,
    column: any,
    columnIndex: number
  ) => {
    const val: string = formatVal(record[column.key], column.format) || '-'
    return (
      <div>{val}</div>
    )
  }
}

export function render() {
  return (
    record: any,
    rowKey: string,
    recordIndex: number,
    column: any,
    columnIndex: number
  ) => {
    const val: string = formatVal(record[column.key], column.format) || '-'
    const dod: string = record[column.key + '_dod']
    const isSummary = ['Sum', 'Average'].includes(record.date)
    const status = getUpAndDownStatus(dod, isSummary)
    const formatDod = isSummary ? '' : formatPercentNum(dod, 1, true)

    return (
      <MetricAndUpDown
        metric={val}
        updown={{ data: formatDod, status }}
        className=''
        style={{}}
        hasTooltip={false}
      />
    )
  }
}



export function getTableDate(time, timeType) {
  switch (timeType) {
    case 'weekly':
      return getCurrWeekfirstDay(time)
    case 'monthly':
      return momentFormat(time, 'YYYY-MM')
    default:
      return time
  }
}

function getCurrWeekfirstDay(date) {
  return momentFormat(moment(date).startOf('isoWeek'))
}

function momentFormat(date, format = 'YYYY-MM-DD') {
  if (typeof date === 'string') {
    date = moment(date)
  }
  return date.format(format)
}
